var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//@ts-check

import { isCrawler, getTrack_points } from './utils';
import { generateScheme } from './scheme';
import geolocate from './geolocate';
import geoCode from './geoCode';
import cat from './cat';
import myLogan from './logan';
import webloc from './webloc';
import { getWeblocCache } from './geos/cache';
import { cookie } from './utils';
import CatClass from './catclass.js';
// @ts-ignore
var version = "0.8.11-alpha.4";
var TrackPoint_MaxCount = 5;
var DEFAULT_OPTIONS = {
    version: version,
    project: 'default', // 建议使用前端项目名，web项目名，package.json的name
    prejectVersion: '-1', // TODO 项目版本号是否要暴露，package.json的version
    debug: false,
    timeout: 1000 * 20,
    htmlTimeout: 1000 * 10, // 默认html定位超时时间（即navigator.geolocation.getCurrentPosition超时时间）
    enableHighAccuracy: true, // 采用html定位策略时,用来表明应用是否使用其最高精度来表示结果。
    maximumAge: 0, // 采用html定位策略时,用来表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。
    geotype: 'WGS84', // TODO 标明美团环境大写，微信环境小写
    city: false,
    cityType: 'meituan', // meituan, dianping
    disable: [],
    enable: [],
    enableBottomline: true, // 当enable所有的策略都失败后，是否启动保底策略（network,cache）
    urlMatchGroup: ['lat', 'lng', 'geotype'],
    global: {},
    uuid: '', // 强烈推荐填写，否则无法定位单个用户信息
    env: 'prod', // 默认为产品环境，dev,prod主要区分cat的上传环境
    key: '',
    cacheTimeout: 5 * 60 * 1000, // 缓存过期时间
    KNBTimeout: 6000, // KNB定位过期时间
    KNBCache: false, // true时使用KNB缓存的地理位置信息,false时改为实时获取
    // KNBBizId: '', // KNB定位依赖的业务标识，参考文档https://km.sankuai.com/page/1217345487
    NXTimeout: 1000, // NX timeout时间，如果NX.getLocation即不success，也不error，则超过NXTimeout时间，认为失败。
    enableLogan: true // 默认为true, 是否启动Logan日志记录，Logan用于存储详细定位日志，当Logan发现定位不准确时，方便定位原因，但是会动态引用Logan标签。需要验证域名是否允许跨域。
};
var ISNORMAL = 1;
var ISUPLOAD = 2;
var ISCACHE = 3;
var bindUnload = false; // 是否绑定关闭浏览器事件
// 检测错误请求
function isBadCase(options) {
    var badCaseMessage = null;
    // 检测是否有爬虫爬取
    if (isCrawler(navigator.userAgent)) {
        badCaseMessage = 'Detect crawler.';
    }
    // key是否存在
    if (!options.key) {
        badCaseMessage = 'key不存在';
    }
    return badCaseMessage;
}
function getConfig(options) {
    // 获取url中设置debug信息，生产环境也可以配置debug
    if (location.search && location.search.indexOf('debugwebloc') !== -1) {
        options.debug = true;
    }
    var config = _extends({}, DEFAULT_OPTIONS, options);
    if (config.uuid.trim().length === 0) {
        // 如果uuid为空字符串，尝试从cookie中获取相关信息
        config.uuid = cookie.getItem('unionid') || cookie.getItem('dpid') || cookie.getItem('_lxsdk_cuid') || '';
    }
    config.debug && console.log('---------- START getCurrentPosition, version: ' + config.version + '----------');
    config.cat = new CatClass({
        env: config.env,
        project: config.project,
        uuid: config.uuid
    });
    return config;
}
function setTrackPoints(result) {
    var trackpoints = [];
    try {
        var trackpointsStr = localStorage.getItem('mars-weblog-trackpoints');
        var cloneGeo = JSON.parse(JSON.stringify(result.geo));
        cloneGeo.type = cloneGeo.geotype.toUpperCase(); // geotype改为type
        delete cloneGeo.geotype;
        trackpoints = trackpointsStr ? JSON.parse(trackpointsStr) : [];
        trackpoints.unshift(cloneGeo); // 数组首位添加点
        localStorage.setItem('mars-weblog-trackpoints', JSON.stringify(trackpoints));
    } catch (e) {}

    return trackpoints;
}

function uploadTrackpoint(config) {
    // 当只需要位置信息时，可以防止日志不全
    window.onunload = function onunload_handler() {
        var track_points = getTrack_points();
        if (track_points) {
            webloc(config, null);
        }
    };
}

/**
 * 获取用户当前的定位和城市信息
 */
export function getCurrentPosition(options, cb) {
    var callback;
    try {
        // 微信定位控件@mtfe/mars-mploc与web定位控件@mtfe/mars-webloc的key名称不一致，微信是authKey，美团是key。
        // 业务方在使用mars - webloc过程中有传authKey的情况导致定位失败的问题。为了避免业务方将key属性名误写为authKey，
        // 因此，添加以下逻辑，当options中key不存在且authKey存在的情况下，将authKey传值给key，以避免业务方传错
        if (options.authKey && !options.key) {
            options.key = options.authKey;
        }
        var badCaseMessage = isBadCase(options);
        var config = getConfig(options);
        config.cat.process.push({ num: 51, timestamp: Date.now() });
        callback = function callback(error, result) {
            cb(error, result);
            config.cat.sendErrorLog();
            config.cat.sendRequestLog();
        };
        if (badCaseMessage) {
            config.cat.pushErrorLog({
                sec_category: 'webloc-fail-badcase',
                level: 'error',
                content: badCaseMessage
            });
            // cat(config, `webloc-fail-badcase`, badCaseMessage);// 记录定位过程信息
            callback(new Error(badCaseMessage));
            return;
        }
        var loc_track = {
            process: {}
        };
        var scheme = generateScheme(config);
        if (!bindUnload && !config.city) {
            // 绑定浏览器事件
            uploadTrackpoint(config);
            bindUnload = true;
        }
        var startTime = Date.now();
        // 获取位置信息
        var finishHandler = function finishHandler(err, result, detail) {
            detail = detail || [];
            // 写入缓存，结果返回给用户
            function responseResult(result) {
                // 记录定位过程日志
                var webloc_config = _extends({}, config);
                delete webloc_config.global;
                loc_track.loc_process = webloc_config.cat.process;
                delete webloc_config.cat;
                loc_track.webloc_config = webloc_config;
                loc_track.loc_duration = Date.now() - startTime;
                config.cat.process.push({ num: 52, timestamp: Date.now() });
                if (webloc_config.enableLogan) {
                    myLogan(loc_track);
                }
                for (var i in loc_track.process) {
                    var requestLog = {
                        name: 'webloc-scheme-' + loc_track.process[i].scheme,
                        statusCode: loc_track.process[i].status,
                        responsetime: loc_track.process[i].duration,
                        content: loc_track.process[i].error
                        // 自动生成策略，每次都会优先判断url，如果url不包含经纬度的话，每次都会产生错误日志，为了减少url日志上报，所以不去上报url日志。
                        // 而且url策略原因非常单一，而且好判断，所以不用根据日志判断
                    };if (loc_track.process[i].scheme !== 'url') {
                        config.cat.pushRequestLog(requestLog);
                    }
                }

                if (result) {
                    result.time = Date.now();
                    // 缓存定位，不会重新设置到缓存中
                    if (result.geo.source !== 'cache') {
                        try {
                            localStorage.setItem('mars-weblog-cache', JSON.stringify(result));
                        } catch (e) {}
                    }
                    result.detail = detail;
                    if (!config.city) {
                        delete result.city;
                    }
                    delete result.geo.id;
                    // 去掉事件戳
                    delete result.time;
                    delete result.geo.altitude;
                    config.cat.pushRequestLog({
                        name: "getCurrentPosition",
                        statusCode: 200, // 500或200
                        responsetime: loc_track.loc_duration,
                        content: "success"
                    });
                    callback(null, result);
                } else {
                    config.cat.pushErrorLog({
                        sec_category: 'webloc-fail',
                        level: 'error',
                        content: loc_track
                    });
                    config.cat.pushRequestLog({
                        name: "getCurrentPosition",
                        statusCode: 500, // 500或200
                        responsetime: loc_track.loc_duration,
                        content: "error"
                    });
                    // cat(config, `webloc-fail`, loc_track);
                    // 最终返回给用户定位失败
                    callback(new Error('Failed to locate.'), { detail: detail });
                }
            }
            // 当走缓存，但是缓存需要城市信息，或缓存的trackpoint需要upload时，web服务返回的定位如果再错误，直接返回responseResult(null);
            function getWebLocResult(geoResult, status) {
                // 需要城市信息，且结果中不存在城市信息（如果是network定位策略，会有城市信息）
                if (config.city && !geoResult.city) {
                    var weblocPromise = webloc(config, geoResult);
                    // 包括缓存获取城市信息与正常获取城市信息
                    handleWebloc(weblocPromise, status);
                } else {
                    // 缓存是否需要对结果加到TrackPoint， 如果是network定位策略，或缓存策略，则不需要对结果缓存到trackpoints
                    if (geoResult.geo.source !== 'network' && geoResult.geo.source !== 'cache') {
                        var trackpoints = setTrackPoints(geoResult);
                        if (trackpoints.length >= TrackPoint_MaxCount) {
                            var _weblocPromise = webloc(config, geoResult);
                            handleWebloc(_weblocPromise, ISUPLOAD);
                        }
                    }
                    // 结果只要不需要城市信息，则直接返回给用户数据
                    responseResult(geoResult);
                }
            }
            // 缓存返回给用户的结果
            function handleWebloc(weblocPromise, status) {
                weblocPromise.then(function (result) {
                    // 如果是ISUPLOAD，则与用户无关
                    if (status === ISNORMAL || status === ISCACHE) {
                        responseResult(result);
                    }
                }).catch(function () {
                    switch (status) {
                        case ISCACHE:
                            {
                                // 缓存获取城市信息失败
                                detail.push(2001); // 缓存缺失城市信息（且通过web定位获取失败）
                                responseResult(null);
                            }
                            break;
                        case ISNORMAL:
                            {
                                // 如果正常情况下调用接口失败了，则去申请缓存
                                var cache = getWeblocCache(config);
                                // 如果disable包含cache，调用失败后，还走cache吗？最后的cache是保底策略，所以走
                                if (cache) {
                                    // 缓存没有过期，5分钟为过期时间
                                    getWebLocResult(cache, ISCACHE); // 由缓存结果向服务器发送请求
                                } else {
                                    // cache 不存在
                                    responseResult(null);
                                }
                            }
                            break;
                        case ISUPLOAD:
                            {
                                // upload trackPoints失败
                                console.error("上传trackupload失败");
                            }
                            break;
                    }
                });
            }
            if (err) {
                if (config.enableBottomline) {
                    config.cat.process.push({ num: 53, timestamp: Date.now() });
                    var weblocPromise = webloc(config, null);
                    handleWebloc(weblocPromise, ISNORMAL);
                } else {
                    config.cat.process.push({ num: 54, timestamp: Date.now() });
                    responseResult(null);
                }
                return;
            }
            getWebLocResult(result, ISNORMAL);
        };

        var hookHandler = function hookHandler(_ref) {
            var scheme = _ref.scheme,
                status = _ref.status,
                duration = _ref.duration,
                data = _ref.data,
                error = _ref.error;

            config.debug && console.log('[' + scheme + ']                     status: ' + status + ',                     duration: ' + duration + ',                     data: ' + JSON.stringify(data) + ',                     error: ' + error);
            loc_track.process[scheme] = {
                scheme: scheme,
                status: error ? 500 : 200,
                duration: duration,
                error: error
            };
        };
        geolocate({
            config: config,
            scheme: scheme,
            finish: finishHandler,
            hook: hookHandler
        });
    } catch (e) {
        if (config && config.cat) {
            config.cat.pushErrorLog({
                sec_category: 'webloc-fail-catch',
                level: 'error',
                content: e
            });
            var responsetime = void 0;
            if (loc_track && loc_track.loc_duration) {
                responsetime = loc_track.loc_duration;
            } else {
                responsetime = 0;
            }
            config.cat.pushRequestLog({
                name: "getCurrentPosition",
                statusCode: 500, // 500或200
                responsetime: responsetime,
                content: "error"
            });
        }

        if (callback) {
            callback(e);
        } else {
            if (config && config.cat) {
                config.cat.sendErrorLog();
                config.cat.sendRequestLog();
            }
            cb(e);
        }
        // cat(options, `webloc-fail-catch`, e);// 记录定位过程信息
    }
}
/**
 * 获取城市信息
 */
export function getCityInfo(options, callback) {
    //options不支持env参数
    try {
        var opts = _extends({
            cityType: 'meituan',
            geotype: 'WGS84',
            env: 'prod',
            version: version
        }, options);

        if ('latitude' in opts && 'longitude' in opts) {
            var config = {
                cityType: opts.cityType,
                city: true,
                env: 'prod',
                global: {},
                geotype: opts.geotype,
                version: opts.version
            };
            webloc(config, {
                geo: {
                    id: Date.now(),
                    longitude: opts.longitude,
                    latitude: opts.latitude,
                    geotype: opts.geotype,
                    source: "city"
                }
            }).then(function (result) {
                callback(null, result.city);
            }).catch(function (err) {
                cat(config, 'webloc-getCityInfo-fail', err); // 记录错误
                callback(new Error('Failed to get city info.'));
            });
        } else {
            var str = 'Missing latitude or longitude param in options.';
            cat(config, 'webloc-getCityInfo-param', str); // 记录错误
            return callback(new Error(str));
        }
    } catch (e) {
        cat(config, 'webloc-getCityInfo-city', e); // 记录错误
        return callback(new Error(e));
    }
}

/**
 * 地理编码
 */
export function addressToGeoCode(params, callback) {
    return geoCode(_extends({}, params), callback || function () {});
}